export const loaders = {
  OVERLAY: 'OVERLAY',
  TOPBAR: 'TOPBAR'
};

export const PLATFORMS = Object.freeze({
  XERO: 'xero',
  QUICKBOOKS: 'quickbooks',
  MYOB: 'myob'
});

export const SYNC_POLL_INTERVALS = Object.freeze({
  ACTIVE_SYNC: 3500,
  MAX_RETRIES: 30
});

